import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveStructuredData } from './structuredData';

const SCRIPT_ATTR = 'data-seo-jsonld';

export default function RouteSchema() {
  const { pathname } = useLocation();

  useEffect(() => {
    document
      .head
      .querySelectorAll(`script[${SCRIPT_ATTR}]`)
      .forEach((el) => el.remove());

    const blocks = resolveStructuredData(pathname);

    blocks.forEach((block) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute(SCRIPT_ATTR, 'true');
      script.textContent = JSON.stringify(block);
      document.head.appendChild(script);
    });
  }, [pathname]);

  return null;
}